import _request from '@/utils/request';
import { _getQuerystr } from '@/utils/commonUtils';


// GET
// /journey/goals
// 获取可选择的目标列表
export const getGoals = () => {
  return _request({
    url: '/journey/goals',
    method: 'GET',
  });
};

// GET
// /journey/lastAdventure
// 获取当前用户最后一次adventure(用来生成首页banner,如果不为空，则根据adventureTemplateId定位图片，否则使用娃娃默认带背景的图)
export const getLastAdventure = () => {
  return _request({
    url: '/journey/lastAdventure',
    method: 'GET',
  });
};

// GET
// /journey/myPlan
// 获取当前用户的计划
export const getMyPlan = () => {
  return _request({
    url: '/journey/myPlan',
    method: 'GET',
  });
};
// POST
// /journey/myPlan
// 根据选择的目标创建plan
export const createMyPlan = (data) => {
  return _request({
    url: '/journey/myPlan',
    method: 'POST',
    data,
  });
};
// GET
// /journey/myPlan/{myPlanId}
// 根据myPlanId获取当前用户今天的任务列表
export const getMyPlanTasks = (myPlanId) => {
  return _request({
    url: `/journey/myPlan/${myPlanId}`,
    method: 'GET',
  });
};
// POST
// /journey/myPlan/subscribeToCalendar
// 根据myPlan加入手机日历
export const subscribeToCalendar = (myPlanId) => {
  return _request({
    url: `/journey/myPlan/subscribeToCalendar?myPlanId=${myPlanId}`,
    method: 'POST',
  });
};
// GET
// /journey/story
// 获取今天的冒险故事
export const getStory = () => {
  return _request({
    url: '/journey/story',
    method: 'GET',
  });
};
// POST
// /journey/story/response
// 回应冒险故事
export const responseStory = (params) => {
  return _request({
    url: '/journey/story/response',
    method: 'POST',
    data: params,
  });
};

// /journey/todayPlan/lastFinishedStory
// 获取最后一次完成的故事，用来渲染页面上半部分的故事图片
export const getLastFinishedStory = () => {
  return _request({
    url: '/journey/todayPlan/lastFinishedStory',
    method: 'GET',
  });
};

// GET:/journey/todayPlan?myPlanId=${myPlanId}
// 根据myPlanId获取今天的计划，用来渲染下半部分今日任务列表和总分
export const getTodayPlan = (myPlanId) => {
  return _request({
    url: `/journey/todayPlan?myPlanId=${myPlanId}`,
    method: 'GET',
  });
};

// POST: /journey/todayPlan/finishTask 完成任务
export const finishTask = (params) => {
  return _request({
    url: '/journey/todayPlan/finishTask',
    method: 'POST',
    data: params,
  });
};

// GET: /journey/todayPlan/story?dailyPlanId=${dailyPlanId}
// 获取计划的故事(查询+分配)
export const getTodayPlanStory = (dailyPlanId) => {
  return _request({
    url: `/journey/todayPlan/story?dailyPlanId=${dailyPlanId}`,
    method: 'GET',
  });
};

// GET: /journey/todayPlan/story?dailyPlanId=${dailyPlanId}
// 获取今日的旅程故事
export const getTodayGeneratedStories = (dailyPlanId) => {
  return _request({
    url: `/journey/todayPlan/generatedStories?dailyPlanId=${dailyPlanId}`,
    method: 'GET',
  });
};

// GET: /journey/todayPlan/storyResponse?todayStoryId=${todayStoryId}
// 根据todayStoryId获取故事和用户回应
export const getStoryResponse = (todayStoryId) => {
  return _request({
    url: `/journey/todayPlan/storyResponse?todayStoryId=${encodeURIComponent(todayStoryId)}`,
    method: 'GET',
  });
};

// POST: /journey/todayPlan/finishStory
// 完成故事
export const finishStory = (data) => {
  return _request({
    url: '/journey/todayPlan/finishStory',
    method: 'POST',
    data,
  });
};
// GET:/journey/timeLineItems?timeLineItemId=${timeLineItemId 如果第一次就不填}&limit=${limit 如果不填默认10条}
// 获取时间线列表
export const getTimeLineItems = (params) => {
  return _request({
    url: `/journey/timeLineItems${_getQuerystr(params)}`,
    method: 'GET',
  });
};

// Get : /journey/getLastInnerChild  获取当前用户最近的娃娃形象，用来画主页上半部分的图
export const getLastInnerChild = () => {
  return _request({
    url: '/journey/getLastInnerChild',
    method: 'GET',
  });
};

// Get : /journey/getLastInnerChildAvatar 获取当前用户最近的娃娃对应的聊天形象，用来发起AI聊天任务
export const getLastInnerChildAvatar = () => {
  return _request({
    url: '/journey/getLastInnerChildAvatar',
    method: 'GET',
  });
};
// GET: /journey/todayPlan/story/image?todayStoryId=${todayStoryId}
// 获取今日故事的合成图片
export const getTodayStoryImage = (todayStoryId) => {
  return _request({
    url: `/journey/todayPlan/story/image?todayStoryId=${encodeURIComponent(todayStoryId)}`,
    method: 'GET',
  });
};

// activityReportId查询报告详情
// /staff/activity/getReport?activityReportId=${activityReportId}
export const getActivityReport = (activityReportId) => {
  return _request({
    url: `/staff/activity/getReport?activityReportId=${activityReportId}`,
    method: 'GET',
  });
};